import { Button, Col, Row, Form, Input, Select, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import React, { ReactElement, useEffect } from 'react'
import {} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../../../compnents/form/DateSelect'
import { SupplierDealingParams } from '../../../../services/supplierDealing'
import {
  getDepartment,
  sleectUserData,
} from '../../../putstorelist/putstorelistSlice'
import { User } from '../../../../models/user'
import styles from './stockMaintenance.module.css'
import {
  pageDurgsystem,
  selectDurgsystemData,
} from '../../../durgsystem/durgsystemSlice'
const { Option } = Select

export const StockMaintenanceQuery = (props: {
  loading?: any
  timeHead?: string
  timeTail?: string
  onValueChange: (queries: SupplierDealingParams) => void
}): ReactElement => {
  const dispatch = useDispatch()

  const [form] = Form.useForm()

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(getDepartment({ current: 1, size: 1000, state: 1 }))
    const [head, tail] = getDateRange(DateRangeType.ThisYear)
    form.setFieldsValue({
      timeHead: head,
      timeTail: tail,
    })
  }, [])
  return (
    <>
      <Form
        form={form}
        onFinish={(values) => {
          if(!values?.timeHead && values?._dateRange == 6){
            return
          }
          props.onValueChange({
            ...values,
            state: values.state !== 2 ? values.state : null,
          })
        }}
      >
        <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
          <Space wrap={false}>
            <Form.Item name='no' noStyle>
              <Input
                autoComplete='off'
                placeholder='养护单号'
                onChange={() => form.submit()}
                prefix={<SearchOutlined />}
                allowClear
                style={{ width: '12rem' }}
              />
            </Form.Item>
            <Form.Item name='storehouseId' noStyle>
              <Select
                placeholder='库房列表'
                allowClear
                dropdownClassName={styles.select}
                onChange={() => form.submit()}
                style={{ width: '8rem' }}
              >
                {durgData.map((v: any) => {
                  return (
                    <Option value={v.id} key={v.id}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item name='mainUserId' noStyle>
              <Select
                placeholder='养护人员列表'
                dropdownClassName={styles.select}
                allowClear
                onChange={() => form.submit()}
                style={{ width: '10rem' }}
              >
                {userData.map((v: User) => {
                  return (
                    <Option value={v.id} key={v.id}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item name='state' noStyle>
              <Select
                placeholder='养护状态'
                dropdownClassName={styles.select}
                allowClear
                onChange={() => form.submit()}
                defaultValue={2}
                style={{ width: '8rem' }}
              >
                <Option value={2}>全部</Option>
                <Option value={0}>养护中</Option>
                <Option value={1}>养护完成</Option>
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8rem' }}
              labelPrefix=''
              namePrefix='time'
              placeholder='养护日期'
              initialValue={DateRangeType.ThisYear}
              onChange={() => form.submit()}
            />
            <Button
              loading={props?.loading}
              type='primary'
              onClick={() => props.onValueChange(form.getFieldsValue())}
            >
              查询
            </Button>
          </Space>
        </Row>
      </Form>
    </>
  )
}
